import { Box, Drawer, BoxProps as IBoxProps, styled } from "@mui/material";

export const SidebarWrapper = styled(
  Box,
  {},
)<Partial<IBoxProps>>(() => ({
  "&.sidebar-container": {
    zIndex: 20,
    position: "fixed",
    width: "100%",
    height: "3.5rem",
    border: "1px solid transparent",
    boxShadow: "0 2px 4px -1px rgba(0, 0, 0, 0.25)",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#fff",
    ".menu-div": {
      width: "100%",
      display: "flex",
      marginLeft: "5%",
      marginRight: "4%",
      gap: ".6rem",
      ".icon": {
        display: "flex",
        alignItems: "center",
        svg: {
          height: "2rem",
          width: "2rem",
        },
      },
      ".search-field": {
        width: "100%",
        display: "flex",
        justifyContent: "center",
      },
    },
  },
}));

export const DrawerWrapper = styled(
  Drawer,
  {},
)<Partial<IBoxProps>>(() => ({
  "&.MuiDrawer-root": {
    marginTop: "3.5rem",
    overflowY: "scroll",
    ".MuiBackdrop-root": {
      marginTop: "3.5rem",
    },
    ".MuiDrawer-paper": {
      padding: "9px 5%",
      width: "91%",
      marginTop: "3.7rem",
    },
    ".drawer-container": {
      zIndex: 20,
      position: "fixed",
      width: "90%",
      height: "3.5rem",
      backgroundColor: "#fff",
      ".menu-div": {
        width: "100%",
        display: "flex",
        gap: ".6rem",
        ".icon": {
          display: "flex",
          alignItems: "center",
          svg: {
            height: "2rem",
            width: "2rem",
          },
        },
        ".search-field": {
          width: "100%",
          display: "flex",
          justifyContent: "center",
          div: {
            width: "100%",
          },
        },
      },
    },
  },
}));
